import React, { useState } from 'react';
import { useNavigate } from "react-router";
import { useNotificationContext } from '../../common/notoficationsContext';
import './notifications.css';

function Notifications() {

  const navigate = useNavigate();

  // ✅ CONTEXT DATA
  const {
    generalNotifications,
    orderNotifications,
    counts,
    loading,
    markAsRead,
    markAllAsRead
  } = useNotificationContext();

  // ✅ ACTIVE TAB
  const [activeTab, setActiveTab] = useState('general');
  
  // ✅ FILTER
const [filterType, setFilterType] =
  useState('all');

// ✅ PAGINATION
const [currentPage, setCurrentPage] =
  useState(1);

const notificationsPerPage = 10;

  const [
    expandedNotification,
    setExpandedNotification
  ] = useState(null);

  // ✅ ROLE
  const role =
    localStorage.getItem("role");

  // ✅ ADMIN CHECK
  const isAdmin =
    role === 'admin' ||
    role === 'CEO';

  // ✅ GROUPING
  const groupNotifications = (
    notificationList
  ) => {

    const groups = {
      today: [],
      yesterday: [],
      older: []
    };

    const now = new Date();

    notificationList.forEach(n => {

      const date =
        new Date(n.createdAt);

      const diff =
        (now - date) /
        (1000 * 60 * 60 * 24);

      if (diff < 1) {

        groups.today.push(n);

      } else if (diff < 2) {

        groups.yesterday.push(n);

      } else {

        groups.older.push(n);

      }

    });

    return groups;

  };

  // ✅ ACTIVE DATA
  const currentNotifications =
    activeTab === 'orders'
      ? orderNotifications
      : generalNotifications;

  // ✅ FILTERED DATA
const filteredNotifications =
  currentNotifications.filter(
    (notification) => {

      // unread
      if (
        filterType === 'unread'
      ) {
        return !notification.isRead;
      }

      // read
      if (
        filterType === 'read'
      ) {
        return notification.isRead;
      }

      // requests
      if (
        filterType === 'request'
      ) {
        return (
          notification.notificationType ===
          'Request'
        );
      }

      // tickets
      if (
        filterType === 'ticket'
      ) {
        return (
          notification.notificationType ===
          'Ticket'
        );
      }

      // orders
      if (
        filterType === 'order'
      ) {
        return (
          notification.notificationType ===
          'Order'
        );
      }

      return true;

    }
  );

// ✅ PAGINATION
const indexOfLastNotification =
  currentPage *
  notificationsPerPage;

const indexOfFirstNotification =
  indexOfLastNotification -
  notificationsPerPage;

const paginatedNotifications =
  filteredNotifications.slice(
    indexOfFirstNotification,
    indexOfLastNotification
  );

// ✅ TOTAL PAGES
const totalPages =
  Math.ceil(
    filteredNotifications.length /
    notificationsPerPage
  );

// ✅ GROUPED
const grouped =
  groupNotifications(
    paginatedNotifications
  );

  // const grouped =
  //   groupNotifications(
  //     currentNotifications
  //   );

  // ✅ NAVIGATION
  const handleNavigate = (
    notification,
    e
  ) => {

    e.stopPropagation();

    if (
      notification.notificationType ===
      "Request"
    ) {

      navigate('/request-details', {
        state: {
          requestDetails: {
            requestId:
              notification.requestId
          }
        }
      });

    } else if (
      notification.notificationType ===
      "Ticket"
    ) {

      navigate("/view-ticket", {
        state: {
          ticket: {
            id: notification.ticketId
          }
        }
      });

    } else if (
      notification.notificationType ===
      "Order" &&
      notification.actionUrl
    ) {

      navigate(
        notification.actionUrl
      );

    }

  };

  // ✅ SECTION RENDER
  const renderSection = (
    title,
    items
  ) => {

    if (!items.length) return null;

    return (

      <div className="notifications-section">

        <h3 className="notifications-section-title">
          {title}
        </h3>

        {items.map(notification => (

          <div
            key={notification.id}
            onClick={() => {

              setExpandedNotification(
                expandedNotification ===
                  notification.id
                  ? null
                  : notification.id
              );

              // ✅ ONLY IF UNREAD
              if (!notification.isRead) {

                markAsRead(
                  notification.id
                );

              }

            }}
            className={`notification-card ${!notification.isRead
                ? 'unread'
                : ''
              }`}
          >

            <p className="notification-user">
              {
                notification.userName ||
                notification.notifyToName ||
                "System"
              }
            </p>

            <p className="notification-date">
              {
                new Date(
                  notification.createdAt
                ).toLocaleString()
              }
            </p>

            {expandedNotification ===
              notification.id && (

                <div className="notification-message">

                  <p>
                    {notification.message}
                  </p>

                  {notification.meta && (

                    <div className="notification-meta">

                      {notification.meta.orderNumber && (
                        <p>
                          Order:
                          {' '}
                          {
                            notification.meta.orderNumber
                          }
                        </p>
                      )}

                      {notification.meta.amount && (
                        <p>
                          Amount:
                          {' '}
                          ₹
                          {
                            notification.meta.amount
                          }
                        </p>
                      )}

                      {notification.meta.customerName && (
                        <p>
                          Customer:
                          {' '}
                          {
                            notification.meta.customerName
                          }
                        </p>
                      )}

                    </div>

                  )}

                  <button
                    className="notification-action-btn"
                    onClick={(e) =>
                      handleNavigate(
                        notification,
                        e
                      )
                    }
                  >
                    View Details →
                  </button>

                </div>

              )}

            {!notification.isRead && (
              <span className="notification-dot"></span>
            )}

          </div>

        ))}

      </div>

    );

  };

  return (

    <div className="notifications-container">

      <h2 className="notifications-header">
        Notifications
      </h2>

      {/* ✅ TABS */}

      <div className="notification-tabs">

        <button
          className={`notification-tab ${activeTab === 'general'
              ? 'active'
              : ''
            }`}
          onClick={() =>
            setActiveTab('general')
          }
        >
          General
          {' '}
          (
          {
            counts.generalUnreadCount
          }
          )
        </button>

        {isAdmin && (

          <button
            className={`notification-tab ${activeTab === 'orders'
                ? 'active'
                : ''
              }`}
            onClick={() =>
              setActiveTab('orders')
            }
          >
            Orders
            {' '}
            (
            {
              counts.orderUnreadCount
            }
            )
          </button>

        )}

      </div>

      {/* ✅ FILTERS */}

<div className="notifications-filter-tabs">

  <button
    className={`filter-btn ${
      filterType === 'all'
        ? 'active-filter'
        : ''
    }`}
    onClick={() => {
      setFilterType('all');
      setCurrentPage(1);
    }}
  >
    All
  </button>

  <button
    className={`filter-btn ${
      filterType === 'unread'
        ? 'active-filter'
        : ''
    }`}
    onClick={() => {
      setFilterType('unread');
      setCurrentPage(1);
    }}
  >
    Unread
  </button>

  <button
    className={`filter-btn ${
      filterType === 'read'
        ? 'active-filter'
        : ''
    }`}
    onClick={() => {
      setFilterType('read');
      setCurrentPage(1);
    }}
  >
    Read
  </button>

  <button
    className={`filter-btn ${
      filterType === 'request'
        ? 'active-filter'
        : ''
    }`}
    onClick={() => {
      setFilterType('request');
      setCurrentPage(1);
    }}
  >
    Requests
  </button>

  <button
    className={`filter-btn ${
      filterType === 'ticket'
        ? 'active-filter'
        : ''
    }`}
    onClick={() => {
      setFilterType('ticket');
      setCurrentPage(1);
    }}
  >
    Tickets
  </button>

  {isAdmin && (

    <button
      className={`filter-btn ${
        filterType === 'order'
          ? 'active-filter'
          : ''
      }`}
      onClick={() => {
        setFilterType('order');
        setCurrentPage(1);
      }}
    >
      Orders
    </button>

  )}

</div>

      {/* ✅ ACTIONS */}

      <div className="notifications-filters">

        <button
          className="notifications-markall-btn"
          onClick={() => {

            const ids =
              currentNotifications.map(
                n => n.id
              );

            markAllAsRead(ids);

          }}
        >
          Mark All as Read
        </button>

      </div>
      

      {/* ✅ LOADING */}

      {loading && (

        <div className="notifications-loader">
          Loading...
        </div>

      )}

      {/* ✅ EMPTY */}

      {!loading &&
        currentNotifications.length === 0 && (

          <div className="notifications-empty">
            No notifications available
          </div>

        )}

      {/* ✅ LIST */}

      {!loading && (

        <>

          {renderSection(
            "Today",
            grouped.today
          )}

          {renderSection(
            "Yesterday",
            grouped.yesterday
          )}

          {renderSection(
            "Older",
            grouped.older
          )}

        </>

      )}

      {/* ✅ PAGINATION */}

{
  totalPages > 1 && (

    <div className="pagination-container">

      <button
        disabled={currentPage === 1}
        className="pagination-btn"
        onClick={() =>
          setCurrentPage(
            prev => prev - 1
          )
        }
      >
        ← Previous
      </button>

      <span className="pagination-page">
        Page {currentPage} of {totalPages}
      </span>

      <button
        disabled={
          currentPage === totalPages
        }
        className="pagination-btn"
        onClick={() =>
          setCurrentPage(
            prev => prev + 1
          )
        }
      >
        Next →
      </button>

    </div>

  )
}

    </div>

  );

}

export default Notifications;





















// import React, { useState, useEffect } from 'react';
// import ApiService, { initialAuthState } from '../../services/ApiService';
// import { useNavigate } from "react-router";
// import { useNotificationContext } from '../../common/notoficationsContext';
// import socket from '../../socket';
// import './notifications.css';

// function Notifications() {
//   const { refreshNotifications } = useNotificationContext();
//   const navigate = useNavigate();

//   const [notifications, setNotifications] = useState([]);
//   const [branches, setBranches] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState('All');
//   const [expandedNotification, setExpandedNotification] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const notifyStaffId = localStorage.getItem("id");

//   const playNotificationSound = () => {
//     const audio = new Audio("/sounds/notification.mp3");

//     audio.play().catch(err => {
//       console.log("Audio blocked:", err);
//     });
//   };

//   // ✅ Fetch Notifications
//   const getAllNotifications = async () => {
//    setLoading(true);

//     try {
//       const payload = {
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode,
//         notifyStaffId,
//         allowedRoles: [localStorage.getItem("role")]
//       };

//       if (selectedBranch !== 'All') {
//         payload.branchName = selectedBranch;
//       }

//       const res = await ApiService.post('/notifications/getAllNotifications', payload);

//       if (res.status) {
//         const branchList = [
//           { branchName: 'All' },
//           ...res.data.result
//             .filter(b => b.branchName)
//             .map(b => ({ branchName: b.branchName }))
//         ];

//         setBranches(branchList);
//         setNotifications(res.data.notifications || []);
//       } else {
//         setNotifications([]);
//         setBranches([{ branchName: 'All' }]);
//       }

//     } catch (err) {
//       console.error("Fetch failed:", err);
//       setNotifications([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAllNotifications();
//   }, [selectedBranch]);

//   // useEffect(() => {

//   //   socket.on("newNotification", (data) => {

//   //     console.log("🔥 Realtime Notification:", data);

//   //     playNotificationSound();

//   //     getAllNotifications();

//   //   });

//   //   return () => {
//   //     socket.off("newNotification");
//   //   };

//   // }, []);

//   // ✅ Mark as Read
//   const markAsRead = async (id) => {
//     try {
//       await ApiService.post('/notifications/markAllAsRead', {
//         ids: [id],
//         isRead: true,
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode
//       });

//       setNotifications(prev =>
//         prev.map(n => n.id === id ? { ...n, isRead: 1 } : n)
//       );

//       refreshNotifications();
//     } catch (err) {
//       console.error("Mark read failed:", err);
//     }
//   };

//   // ✅ Mark All
//   const markAllAsRead = async () => {
//     try {
//       const ids = notifications.map(n => n.id);

//       await ApiService.post('/notifications/markAllAsRead', {
//         ids,
//         isRead: true,
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode
//       });

//       setNotifications(prev => prev.map(n => ({ ...n, isRead: 1 })));
//       refreshNotifications();

//     } catch (err) {
//       console.error("Mark all failed:", err);
//     }
//   };

//   // ✅ Grouping
//   const groupNotifications = () => {
//     const groups = { today: [], yesterday: [], older: [] };
//     const now = new Date();

//     notifications.forEach(n => {
//       const date = new Date(n.createdAt);
//       const diff = (now - date) / (1000 * 60 * 60 * 24);

//       if (diff < 1) groups.today.push(n);
//       else if (diff < 2) groups.yesterday.push(n);
//       else groups.older.push(n);
//     });

//     return groups;
//   };

//   const grouped = groupNotifications();

//   const handleNavigate = (notification, e) => {
//     e.stopPropagation(); // 🔥 VERY IMPORTANT

//     if (notification.notificationType === "Request") {
//       navigate('/request-details', {
//         state: { requestDetails: { requestId: notification.requestId } }
//       });
//     } else if (notification.notificationType === "Ticket") {
//       navigate("/view-ticket", {
//         state: { ticket: { id: notification.ticketId } }
//       });
//     } else if (notification.notificationType === "Order" && notification.actionUrl) {
//       navigate(notification.actionUrl);
//     }
//   };

//   const renderSection = (title, items) => {
//     if (!items.length) return null;

//     return (
//       <div className="notifications-section">
//         <h3 className="notifications-section-title">{title}</h3>

//         {items.map(notification => (
//           <div
//             key={notification.id}
//             onClick={() => {
//               setExpandedNotification(
//                 expandedNotification === notification.id ? null : notification.id
//               );

//               markAsRead(notification.id);
//             }}
//             className={`notification-card ${!notification.isRead ? 'unread' : ''}`}
//           >
//             <p className="notification-user">
//               {notification.userName || notification.notifyToName || "System"}
//             </p>

//             <p className="notification-date">
//               {new Date(notification.createdAt).toLocaleString()}
//             </p>

//             {expandedNotification === notification.id && (
//               <div className="notification-message">

//                 <p>{notification.message}</p>

//                 {notification.meta && (
//                   <div className="notification-meta">
//                     {notification.meta.orderNumber && <p>Order: {notification.meta.orderNumber}</p>}
//                     {notification.meta.amount && <p>Amount: ₹{notification.meta.amount}</p>}
//                     {notification.meta.customerName && <p>Customer: {notification.meta.customerName}</p>}
//                   </div>
//                 )}

//                 {/* ✅ NAVIGATION BUTTON */}
//                 <button
//                   className="notification-action-btn"
//                   onClick={(e) => handleNavigate(notification, e)}
//                 >
//                   View Details →
//                 </button>

//               </div>
//             )}

//             {!notification.isRead && (
//               <span className="notification-dot"></span>
//             )}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="notifications-container">
//       <h2 className="notifications-header">Notifications</h2>

//       <div className="notifications-filters">
//         <select
//           className="notifications-dropdown"
//           value={selectedBranch}
//           onChange={(e) => setSelectedBranch(e.target.value)}
//         >
//           {branches.map(b => (
//             <option key={b.branchName} value={b.branchName}>
//               {b.branchName}
//             </option>
//           ))}
//         </select>

//         <button className="notifications-markall-btn" onClick={markAllAsRead}>
//           Mark All as Read
//         </button>
//       </div>

//       {loading && <div className="notifications-loader">Loading...</div>}

//       {!loading && notifications.length === 0 && (
//         <div className="notifications-empty">No notifications available</div>
//       )}

//       {!loading && (
//         <>
//           {renderSection("Today", grouped.today)}
//           {renderSection("Yesterday", grouped.yesterday)}
//           {renderSection("Older", grouped.older)}
//         </>
//       )}
//     </div>
//   );
// }

// export default Notifications;





// import React, { useState, useEffect } from 'react';
// import ApiService from '../../services/ApiService';
// import { initialAuthState } from '../../services/ApiService';
// import { useNavigate } from "react-router";
// import { useNotificationContext } from '../../common/notoficationsContext';

// function Notifications() {
//   const { refreshNotifications } = useNotificationContext();
//   const [notifications, setNotifications] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState('All');
//   const [expandedNotification, setExpandedNotification] = useState(null);
//   const [branches, setBranches] = useState([]);
//   const navigate = useNavigate();
//   const getAllNotifications = async (branchName = 'All') => {
//     const notifyStaffId=localStorage.getItem("id")

//     try {
//       const payload = {
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode,
//         notifyStaffId:notifyStaffId
//       };

//       if (branchName !== 'All') {
//         payload.branchName = branchName;
//       }

//       const res = await ApiService.post('/notifications/getAllNotifications', payload);

//       if (res.status) {
//         setBranches([
//           { branchName: 'All' },
//           ...res.data.result.map((branch) => ({
//             branchName: branch.branchName,
//           })),
//         ]);
//         const unreadNotifications = res.data.notifications.filter(item => item.isRead === 0);
//         setNotifications(unreadNotifications || []);
//       } else {
//         setBranches([{ branchName: 'All' }]);
//         setNotifications([]);
//       }
//     } catch (err) {
//       console.error('Failed to fetch notifications:', err);
//       setNotifications([]);
//       setBranches([{ branchName: 'All' }]);
//     }
//   };

//   useEffect(() => {
//     getAllNotifications(selectedBranch);
//   }, [selectedBranch]);

//   // Mark single notification as read
//   const markAsRead = async (id) => {
//     try {
//       const response = await ApiService.post('/notifications/markAllAsRead', {
//         ids: [id], // Send an array with one id for single mark as read
//         isRead: true,
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode
//       });
//       if (response.status) {
//         setNotifications((prevNotifications) =>
//           prevNotifications.map((notification) =>
//             notification.id === id ? { ...notification, isRead: 1 } : notification
//           )
//         );
//         refreshNotifications();
//       }
//     } catch (error) {
//       console.error('Error marking notification as read:', error);
//     }
//   };
  
//   // Toggle expand/collapse for a notification and mark as read if expanded
//   const toggleExpand = (id) => {
//     setNotifications((prevNotifications) =>
//       prevNotifications.map((notification) =>
//         notification.id === id ? { ...notification, isRead: 1 } : notification
//       )
//     );
//     setExpandedNotification(expandedNotification === id ? null : id);
//   };

//   // Mark all notifications as read
//   const markAllAsRead = async () => {
//     try {
//       const ids = notifications.map((notification) => notification.id);
//       const response = await ApiService.post('/notifications/markAllAsRead', {
//         ids, // Send an array of all ids
//         isRead: true,
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode
//       });
//       if (response.status) {
//         setNotifications((prevNotifications) =>
//           prevNotifications.map((notification) => ({
//             ...notification,
//             isRead: 1,
//           }))
//         );
//         refreshNotifications()
//       }
//     } catch (error) {
//       console.error('Error marking all notifications as read:', error);
//     }
//   };

//   const handleBranchSelection = (branch) => {
//     setSelectedBranch(branch);
//   };

//   // Filter notifications based on selected branch
//   const filteredNotifications =
//     selectedBranch === 'All'
//       ? notifications
//       : notifications.filter(
//         (notification) => notification.branchName === selectedBranch
//       );

//   return (
//     <div className="p-6 w-full max-w-4xl mx-auto">
//       <h2 className="text-xl font-semibold mb-4">Notifications</h2>

//       {/* Branch Selection Dropdown */}
//       <div className="flex gap-4 mb-4">
//         <label htmlFor="branchDropdown" className="font-medium mr-2">
//           Select Branch:
//         </label>
//         <select
//           id="branchDropdown"
//           value={selectedBranch}
//           onChange={(e) => handleBranchSelection(e.target.value)}
//           className="px-4 py-2 border border-gray-300 rounded-md"
//         >
//           {branches.map((branch) => (
//             <option key={branch.branchName} value={branch.branchName}>
//               {branch.branchName}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* Mark All as Read Button */}
//       <button
//         onClick={markAllAsRead}
//         className="text-blue-600 font-medium ml-auto mb-4"
//       >
//         Mark All as Read
//       </button>

//       {/* Notifications List */}
//       <div>
//         {filteredNotifications.map((notification) => (
//           <div
//             key={notification.id}
//             onClick={() => {
//               markAsRead(notification.id)
//               if (notification.notificationType === "Request") {
//                 navigate('/request-details', { state: { requestDetails: {requestId:notification.requestId} } });
//               } else if (notification.notificationType === "Ticket") {
//                 navigate("/view-ticket", { state: { ticket: {id:notification.ticketId} } })
//               }
//             }}
//             className="bg-white shadow-md rounded-lg p-4 mb-3 flex items-start cursor-pointer transition-all duration-300"
//           >
//             <div
//               key={notification.id}
//               onClick={() => toggleExpand(notification.id)}
//               className="bg-white shadow-md rounded-lg p-4 mb-3 flex items-start cursor-pointer transition-all duration-300"
//             >
//               <div className="flex-1">
//                 <p className="font-medium">{notification.user}</p>
//                 <p className="text-sm text-gray-500">{notification.createdAt}</p>
//                 {expandedNotification === notification.id && (
//                   <div className="mt-3">
//                     <p className="text-gray-600">{notification.message}</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//             {/* Unread Notification Badge */}
//             {/* {!notification.isRead && (
//               <div className="w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center text-xs">
//                 {notification.id}
//               </div>
//             )} */}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Notifications;
